import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  sectionWrapper: {
    marginBottom: '40px',
  },
  sectionHeaderWrapper: {
    marginTop: '48px',
    justifyContent: 'center',
  },
  sectionHeaderHeading: {
    textAlign: 'center',
  },
  sectionHeaderDescription: {
    textAlign: 'center',
    marginTop: '16px',
  },
  collageWrapper: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(12, 1fr)',
    },
    gap: { xs: '16px', md: '24px' },
    padding: { xs: '24px', md: '8px' },
    width: '100%',
    marginTop: '40px',
    paddingBottom: {
      xs: '24px',
      md: '32px',
    },
    justifyContent: 'center',
    '& > div': {
      height: '215px',
      borderRadius: '8px',
      overflow: 'hidden',
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
  },
  imgWrapper: {
    position: 'relative',
    '& img': {
      objectFit: 'cover',
    },
  },
  img: {
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    objectFit: 'cover',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
